import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  audit = false;
  userActivity = false;
  homeActive = false;
  manageFolderStructure = false;
  searchActive = false;
  personalBrowserActive = false;
  uploadAssetsActive = false;
  
  constructor(private http: HttpClient) { }

  getConfig() {
    return this.http.get("assets/config/versionInfo.json");
  }

  changeTab(tab) {
    this.homeActive = false;
    this.searchActive = false;
    this.personalBrowserActive = false;
    if (tab === 0) {
      this.homeActive = true;
    } else if (tab === 1) {
      this.searchActive = true;
    } else if (tab === 2) {
      this.personalBrowserActive = true;
    }
  }

  changeTabUser(tab) {
   this.audit = false;
   this.userActivity = false;
   this.manageFolderStructure = false;
    if (tab === 0) {
      this.audit = true;
    } else if (tab === 1) {
      this.userActivity = true;
    } else if (tab === 2) {
      this.manageFolderStructure = true;
    } 
  }
}
